import deleveryRemixCreatePrecondition from './delevery-remix-create-precondition'
import deleveryRemixInfo from './delevery-remix-info'
import deleveryRemixWater from './delevery-remix-water'

const { getData, postData } = require('js/api/getdata').default

/**
 * 外链创建先决条件接口
 * @param neid 文件的neid
 * @param isCreate 是否为新外链,根据打开页面的位置人为操作数据获得
 * @return {Promise<any>}
 */
export const deliveryGetCreatePreconditionMethods = (params) => {
  // 该条外链请求,外链创建先决条件接口的参数集合
  const getCreatePreconditionParams = {
    nsid: params.nsid,
    neid: params.neid,
    is_create: params.isCreate,
  }
  return new Promise((resolve, reject) => {
    postData('createLinkPrecondition', getCreatePreconditionParams).then((paramRes) => {
      let res = paramRes
      res = deleveryRemixCreatePrecondition(params.type, params.authData, res.data)
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * 单条外链查询接口
 * @param code 当前外链的cdoe码
 * @return {Promise<any>}
 */

export const deliveryInfoMethods = (params) => new Promise((resolve) => {
  const res = deleveryRemixInfo(params.linkShareFormDataTranscript, params)
  resolve(res)
})

/**
 * 创建or修改外链接口
 * @param path 当前外链的路径
 * @param path_type 当前外链的归属地例如ent
 * @return {Promise<any>}
 */

export const deliveryCreateMethods = (params) => {
  const deliveryCreateParams = {
    path: params.path,
    path_type: params.path_type,
    ...params.linkShareSubmitFormDataParams,
  }
  return new Promise((resolve, reject) => {
    postData('createLink', deliveryCreateParams).then((paramRes) => {
      let res = paramRes
      res = {
        URL_VALUE: res.data.url,
        EOD_ID_VALUE: res.data.eod_id > -1 ? res.data.eod.id : null,
        LINK_ID: true,
        LINK_ID_VALUE: res.data.id,
        DELIVERY_ID: true,
        PASSWORD: res.data.password || '',
        DELIVERY_ID_VALUE: res.data.code,
        REMAIN_DOWNLOAD: res.data.remain_download > -1,
        INFO_REMAIN_DOWNLOAD_VALUE: res.data.remain_download > -1 ? res.data.remain_download : null,
      }
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 水印是否强制打勾查询接口
// eslint-disable-next-line max-len
export const deliveryConfigGetMethods = (canAddWaterMark, params) => new Promise((resolve, reject) => {
  getData('WaterMarkForce', {
    name: 'is_open_watermark',
    config_type: 0,
    config_id: 0,
  }).then((paramRes) => {
    let res = paramRes
    res = deleveryRemixWater(canAddWaterMark, params, res.data[0])
    resolve(res)
  }).catch((err) => {
    reject(err)
  })
})

// 服务器水印服务是否开启以及水印内容接口
// eslint-disable-next-line max-len
export const deliverySystemGetWaterMarkMethods = (canAddWaterMark, params) => new Promise((resolve, reject) => {
  getData('getWaterMark').then((paramRes) => {
    let res = paramRes
    res = deleveryRemixWater(canAddWaterMark, params, res.data, 'getWaterMark')
    resolve(res)
  }).catch((err) => {
    reject(err)
  })
})
